ACC.customarticlecode = {

		bindAll: function ()
		{
			ACC.customarticlecode.bindShowCustomArticleCodePopup();
			ACC.customarticlecode.bindSetCustomArticleCode();
			ACC.customarticlecode.bindHideCustomArticleCode();
			ACC.customarticlecode.bindShowCustomCustomerProductCode();
		},
		
		bindShowCustomArticleCodePopup:function(){
	        $(".showPopupForCustomCode").on("click", function(e){
	            e.preventDefault();
	            var $wrapper = $(this).closest('.js-variant-custom-code');
	            var maxLeft = Math.max($wrapper.position().left,$wrapper.position().left);
	            var maxLeft2 = $wrapper.position().left;
	            var linkLength = $(this).outerWidth(true)/2;
	            var popupLength = $wrapper.find(".custom_code_popup").width()/2;
	            $wrapper.find(".custom_code_popup_wrapper").removeClass('hide');
	            $wrapper.find('.custom_code_popup').css("left", maxLeft - maxLeft2 - popupLength + linkLength);
	            $wrapper.find(".errorMsgUsedCode").addClass('hide');
	            $wrapper.find(".errorMsgGenerallError").addClass('hide');
	        });
	    },
	    
	    bindSetCustomArticleCode: function(){
	        $(".send_custom_code").on("click",function(e){
	            e.preventDefault();

	            var form = $(this).closest('form');
	            var url = form.attr('action');

	            var $wrapper = $(this).closest('.js-variant-custom-code');
	            var productCode = $wrapper.find(".custom_code_input").val().trim();
	            $wrapper.find(".custom_code_input").val(productCode);

	            $wrapper.find(".errorMsgUsedCode").addClass('hide');
	            $wrapper.find(".errorMsgGenerallError").addClass('hide');

	            $.ajax({
	                url: url,
	                data: {customerProductId: productCode},
	                type: "POST",
	                success: function (data, response) {
	                	$wrapper.find(".customCode").text(data);
	    	            $wrapper.find(".custom_code_input").val(data);
	    	            $wrapper.find(".custom_code_popup_wrapper").addClass('hide');
	    	            if($wrapper.find(".custom_code_input").val().length > 0) {
	    	                $wrapper.find(".noCustomCode").addClass('hide');
	    	                $wrapper.find(".setCustomCode").removeClass('hide');
	    	            }else{
	    	                $wrapper.find(".setCustomCode").addClass('hide');
	    	                $wrapper.find(".noCustomCode").removeClass('hide');
	    	            }
	                },
	                error: function (response) {
	                	switch (response.status) {
							case 400:
                                $wrapper.find(".errorMsgCodeTooLong").removeClass('hide');
								break;
							case 406:
                                $wrapper.find(".errorMsgUsedCode").removeClass('hide');
                                break;
							default:
                                $wrapper.find(".errorMsgGenerallError").removeClass('hide');
                                break;
						}
	                }
	            });
	        });
	    },
	    
	    bindHideCustomArticleCode: function(){
	        $('.custom_code_popup_cancel').on('click', function (e) {
	            e.preventDefault();
	            $(this).closest('.custom_code_popup_wrapper').addClass("hide");
	        });
	    },
	    
	    bindShowCustomCustomerProductCode: function () {
	        $(".customCode").each(function () {
	            if ($(this).text().trim().length > 0) {
	                var $wrapper = $(this).closest('.js-variant-custom-code');
	                $wrapper.find(".noCustomCode").addClass('hide');
	                $wrapper.find(".setCustomCode").removeClass('hide');
	                $wrapper.find(".custom_code_input").val($wrapper.find(".customCode").text().trim());
	            }
	        });
	    }
};

$(document).ready(function () {
    if ($(".customProductNumber").length) {
    	
    	$(document).mouseup(function (e) {
            var container = $('.custom_code_popup_wrapper');
            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0 // ... nor a descendant of the container
                && container.is(":visible")) {
                container.addClass('hide');
            }
        });
    	
    }
});
